<div class="preview-container">
  <div class="preview-title">
    Preview
    <button mat-icon-button [mat-dialog-close] aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="preview-application-content">
    <div class="main neutral-theme">
      <div class="header" fxLayout="column" fxlayout.gt-xs="row" fxLayoutAlign="center center">
        <div *ngIf="logoUrl">
          <img [src]="logoUrl" />
        </div>
      </div>
      <div class="container" style="flex-direction: column; box-sizing: border-box; display: flex">
        <survey *ngIf="isSurvey" class="application-content" [inPreviewMode]="true" [previewFormId]="form?.id"></survey>
        <app-application
          *ngIf="!isApplicationSubmitted && !isSurvey"
          class="application-content"
          [previewFormId]="form?.id"
          [onPreviewSubmit]="submitApplication"
        ></app-application>
        <div class="confirmation-container">
          <app-application-confirmation
            *ngIf="isApplicationSubmitted && !isSurvey"
            [previewForm]="form"
          ></app-application-confirmation>
        </div>
      </div>
    </div>
  </div>
</div>
